module.exports = __webpack_public_path__ + "media/assets/images/flags/io-a8666900c76dd78df0cf70b5537f36b0.svg";